import React from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../../../common/types';
import { ChannelMark } from './ChannelMark';
import { useRollout } from './RolloutContext';
import type { StepChannelState, StepChannelView } from './rolloutModel';
import { rolloutMessages } from './rolloutMessages';
import { hourInZone } from './rolloutTime';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the run sheet; each part uses its own slice of it */
import styles from './Rollout.module.scss';
/* eslint-enable css-modules/no-unused-class */

const PILL_CLASS: Record<StepChannelState, string | undefined> = {
  notPlanned: styles.pillNp,
  draft: styles.pillDr,
  scheduled: styles.pillSch,
  needsYou: styles.pillSch,
  publishing: styles.pillSch,
  posted: styles.pillOk,
  failed: styles.pillBad,
};

const PILL_STATE = {
  notPlanned: rolloutMessages.pillNotPlanned,
  draft: rolloutMessages.pillDraft,
  scheduled: rolloutMessages.pillScheduled,
  needsYou: rolloutMessages.pillNeedsYou,
  publishing: rolloutMessages.pillPublishing,
  posted: rolloutMessages.pillPosted,
  failed: rolloutMessages.pillFailed,
} as const;

interface ChannelPillProps {
  channel: StepChannelView;
  /** The time shows (design a1, b1); the phone hides it on a posted channel (d1). */
  showTime?: boolean;
}

/** One channel of a step with its own state (design rollout-plan `.cp`): one failed channel never hides the others. */
const ChannelPillComponent: React.FC<ChannelPillProps> = ({ channel, showTime = true }) => {
  const intl = useIntl();
  const { timeZone } = useRollout();
  return (
    <span className={clsx(styles.pill, PILL_CLASS[channel.state])}>
      <ChannelMark platform={channel.platform} small />
      {showTime && <span className={styles.pillTime}>{hourInZone(intl, channel.at, timeZone)}</span>}
      <span className={styles.pillState}>{intl.formatMessage(PILL_STATE[channel.state])}</span>
    </span>
  );
};

export const ChannelPill = TypedMemo(ChannelPillComponent);
